import { Button, Dialog, EButtonColor } from '@web_opxp/components';
import { renderMultilineLoca, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import './SubscriptionConditions.scss';

const SubsciptionConditions: React.FC = () => {
  const { t } = useTranslation();
  const [isDialogOpen, setDialog] = React.useState(false);

  const handleDialogClose = () => {
    setDialog(false);
  };
  const handleDialogOpen = () => (event: React.MouseEvent) => {
    event.preventDefault();
    setDialog(true);
  };
  const handleDialogEnter = () => (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      setDialog(true);
    }
  };

  const dialogContent = renderMultilineLoca(t('Subscription.Conditions.Content'));
  return (
    <span className="subscription-conditions-wrapper">
      &nbsp;|&nbsp;
      <span
        className="conditions-dialog-open-link"
        onClick={handleDialogOpen()}
        data-testid="conditions-link"
        onKeyUp={handleDialogEnter}>
        {t('Subscription.Conditions.Button')}
      </span>
      <Dialog
        className="conditions-dialog"
        onClose={handleDialogClose}
        title={t('Subscription.Conditions.Title')}
        isOpen={isDialogOpen}
        bodyClassName="conditions-dialog-body">
        {dialogContent}
        <div className="conditions-dialog-button-wrapper">
          <Button
            className="conditions-dialog-close-button"
            onClick={handleDialogClose}
            color={EButtonColor.blue}
            label={t('Subscription.Conditions.Dialog.Close')}
          />
        </div>
      </Dialog>
    </span>
  );
};

export default SubsciptionConditions;
